import { useEffect } from "react";
import { Toast, ToastContainer, Button } from "react-bootstrap";
import successIcon from "./../../images/Success.svg";
import errorIcon from "./../../images/Error.svg";
import closeIcon from "./../../images/Cross.svg";

const ToastItem = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast.show && toast.autoHide !== false) {
      const timer = setTimeout(() => {
        onClose();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [toast.show, toast.autoHide, onClose]);

  return (
    <Toast show={toast.show} onClose={onClose} className={["p-2", toast.variant === 'success' && "bg-success", toast.variant === 'danger' && "bg-error"]} style={{width: 420, maxWidth: '100%'}}>
      <Toast.Body className={["py-0 d-flex", toast.variant != 'warning' && "text-white", !toast.message && 'my-2']} style={{alignItems: 'start'}}>
        {toast.variant === 'success' && <img src={successIcon} alt="success icon" className="me-3 mt-1" />}
        {toast.variant === 'danger' && <img src={errorIcon} alt="error icon" className="me-3 mt-1" />}
        <div>
          {toast.title && (
            <div className="w-100">
              <b>{toast.title}</b>
            </div>
          )}
          {toast.message?.split("\n").map((p, i) => (
            <p className="mb-0" key={i}>
              {p}
            </p>
          ))}
        </div>
        {toast.action ? (
          <div className="mt-3">
            <Button
              className="racq-primary-btn w-100"
              variant={toast.action.variant || "primary"}
              onClick={() => {
                toast.action.onClick();
                onClose();
              }}
            >
              {toast.action.label}
            </Button>
            <Button
              className="w-100 mt-3"
              variant="outline-secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
        ) : 
        <button className="ms-auto bg-transparent p-0 border-0" onClick={onClose}><img src={closeIcon} alt="close icon" /></button>}
      </Toast.Body>
    </Toast>
  );
};

// Combined Toast Notifications Container
const ToastNotifications = ({ toasts, onCloseToast }) => {
  // Separate toasts by type for different positioning
  const sessionExpiredToasts = toasts.filter(
    (toast) => toast.type === "sessionExpiredWithAction",
  );
  const regularToasts = toasts.filter(
    (toast) => toast.type !== "sessionExpiredWithAction",
  );

  return (
    <>
      {/* Regular toasts - top-right corner */}
      <ToastContainer
        position="bottom-center"
        className="p-3"
        style={{ zIndex: 1050, position: 'fixed' }}
      >
        {regularToasts.map((toast) => (
          <ToastItem
            key={toast.id}
            toast={toast}
            onClose={() => onCloseToast(toast.id)}
          />
        ))}
      </ToastContainer>

      {/* Session expired toasts - center of screen */}
      {sessionExpiredToasts.length > 0 && (
        <div
          className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            top: 0,
            left: 0,
            zIndex: 1055,
            pointerEvents: "none", // Allow clicks through the backdrop
          }}
        >
          <div style={{ pointerEvents: "auto" }}>
            {sessionExpiredToasts.map((toast) => (
              <ToastItem
                key={toast.id}
                toast={toast}
                onClose={() => onCloseToast(toast.id)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ToastNotifications;
